export const SET_ENTRY_ROUTE = 'SET_ENTRY_ROUTE';
export const UNSET_ENTRY_ROUTE = 'UNSET_ENTRY_ROUTE';
const initialState = '';
export const entryRouteReducer = (state: string = initialState, action: Action<{}>) => {
  switch (action.type) {
    case SET_ENTRY_ROUTE:
      return action.payload;

    case UNSET_ENTRY_ROUTE:
      return initialState;

    default:
      return state;
  }
};
